import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  useBreakpointValue,
} from '@chakra-ui/react';
import SettingsPage from './SettingsPage';
import useIsPhone from '../../hooks/useIsPhone';
import PhoneSettingsList from '../phone/PhoneSettingsList';

// The phone gets a full-height list instead; the desktop modal stays as it was.
export default function SettingsModal(props) {
  return useIsPhone() ? <PhoneSettingsList {...props} /> : <SettingsModalDesktop {...props} />;
}

function SettingsModalDesktop({ isOpen, onClose, initialSection }) {
  const size = useBreakpointValue({ base: 'full', md: 'xl' });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      isCentered
      motionPreset="scale"
      autoFocus={false}
    >
      <ModalOverlay />
      <ModalContent
        bg="redesign.bg.surface"
        borderRadius={{ base: 0, md: '16px' }}
        borderWidth={{ base: 0, md: '1px' }}
        borderStyle="solid"
        borderColor="redesign.border"
        overflow="hidden"
        maxW={{ base: '100vw', md: 'calc(100vw - 48px)', lg: '820px' }}
        w={{ base: '100vw', md: 'calc(100vw - 48px)', lg: '820px' }}
        h={{ base: '100vh', md: '580px' }}
        maxH={{ base: '100vh', md: 'calc(100vh - 48px)' }}
        my={{ base: 0, md: 4 }}
      >
        <ModalCloseButton
          top={{ base: 2, md: 3 }}
          right={{ base: 2, md: 3 }}
          size="sm"
          fontSize="2xs"
          zIndex={2}
          color="redesign.text.muted"
          _hover={{ bg: 'redesign.bg.hover', color: 'redesign.heading' }}
        />
        <SettingsPage onClose={onClose} initialSection={initialSection} />
      </ModalContent>
    </Modal>
  );
}
